module.exports = __webpack_public_path__ + "static/33-55e13f144a0601b0c00de9bf9abb5750.png";